import 
    React,
    {
        useEffect,
        useRef,
    } 
from 'react'
import {
    useDispatch,
    useSelector
} from 'react-redux'

// Constant
import { TEMPLATE } from '../../constants'

// Components
import * as BTNotify from './components/BTNotification'

// Services
import { wsContainer } from '../../services/websocket'
import { TIME } from '../../services/util'

// Redux Action
import { 
    v3_notifications,
    // v3_vehicleLogs
    // v3_vamReminders, 
    // v3_vamEntries, 
} from '../../services/redux/actions'
import { get_user_info_cms_request } from '../../services/redux/actions/liveCamera'

const {
    PACKAGE
} = TEMPLATE

const {
    WS_PROCESS_PACKAGE
} = PACKAGE

const {
    get_notification_request_thru_ws_request
} = v3_notifications

const BackgroundTask = () => {

    const dispatch = useDispatch()

    /**
     *  Steps of Front-end Geocoding
     * 
     *  1. Inititalization
     *      -- Call get address's API of all locations
     *      -- Put all locations into prevLocations useRef
     * 
     *  2. Put interval 30-sec get address's API separately from ws; due to differences from 3-sec ws interval
     *      -- Every 30-sec, interval checks whether the updated states is different from stored prevLocations
     *      -- If different latitude from same vehicle found, call get address API then overwrite prevLocations
     */

    const vehicleStatics = useSelector(state => state.containers.v3.vehicles.staticsByID)
    const drivers = useSelector(state => state.containers.v3.drivers.byID)

    const vehicleStaticsRef = useRef(vehicleStatics)
    const driversRef = useRef(drivers)

    useEffect(() => {
        vehicleStaticsRef.current = vehicleStatics
    }, [vehicleStatics])

    useEffect(() => {
        driversRef.current = drivers
    }, [drivers])

    useEffect(() => {
        const interval = setInterval(() => dispatch(get_user_info_cms_request()), 15 * (1000 * 60))
        // const interval = setInterval(() => dispatch(get_user_info_cms_request()), 1000)

        return () => clearInterval(interval)
    }, [])

    // Websocket
    useEffect(() => {

        wsContainer(
            (err, data) => {

                if(!err) {
                    const {
                        // id: refID,
                        mode,
                        item
                    } = data

                    switch(mode) {
                        // case WS_PROCESS_PACKAGE.GEO: {
                        //     const vid = refID

                        //     vid && dispatch(update_vehicle_geo_state_thru_ws_request(vid, item))

                        //     break;
                        // }
                        // case WS_PROCESS_PACKAGE.VHC: {
                        //     const vid = refID
        
                        //     vid && dispatch(update_vehicle_info_thru_ws_request(vid, item))

                        //     break;
                        // }
                        case WS_PROCESS_PACKAGE.NOTIFY: {
                            
                            const vid = item.vid
                            const statics = vehicleStaticsRef.current
                            const drvs = driversRef.current
                            const plate = statics[vid]?.plate || statics[vid]?.displayName || vid || '-'
                            const drvid = statics[vid]?.drvid

                            const driver = drvid && drvs[drvid]

                            BTNotify.NotifyWarn(plate, <>{driver && `${driver?.name} ${driver.contact}` || '-'}<br/>{item.name} at {TIME.parseTime(TIME.getCurTime())}</>)

                            dispatch(get_notification_request_thru_ws_request({ 
                                rule: item, 
                                vid: vid, 
                                vehicleTime: TIME.getCurTime() 
                            }))

                            break;
                        }
                        default: {
                            break;
                        }
                    }
                }
                
            },
            () => {
                // resubscribe
            }
        )


    }, [])

    return (
        <></>
    )
}

export default BackgroundTask

export {
    BTNotify
}